import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConstantsService {
  public HOME_URL = environment.serverUrl;
  public IMPORT_FILE_EXTNS = ['xlsx', 'xls'];
  public FILE_SIZE = 190 * 1024;
  public IMG_EXTNS = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG'];
  public FILE_EXTNS = [
    'jpg',
    'JPG',
    'jpeg',
    'JPEG',
    'png',
    'PNG',
    'pdf',
    'PDF',
  ];

  constructor() {}

  public MESSAGES: any = {
    ERROR: 'Could not perform the request',
    UNAUTHORIZED: "You're not authorized to access this page",
    FORBIDDEN: "You don't have permission to access this page",
  };

  public RESPONSE_CODES: any = {
    SUCCESS: '200',
  };

  // Server Url
  public SERVER_URLS: any = {
    LOGIN: 'user/login',
  };

  public VALIDATION_PATTERNS: any = {
    EMAIL:
      '^(?=.{1,64}@)[A-Za-z0-9_-]+(\\.[A-Za-z0-9_-]+)*@[^-][A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$',
    MOBILE: '(^$|[0-9]{10})',
    ZIP_CODE: '(^$|[0-9]{6})',
  };

  public getSessionStorage(): Storage | null {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  }

  public getAuthHeader() {
    const storage = this.getSessionStorage();
    if (storage && storage.getItem('currentUser')) {
      let user = JSON.parse(storage.getItem('currentUser')!);
      return 'Bearer ' + (user && user.sessionToken ? user.sessionToken : '');
    } else {
      return '';
    }
  }

  public convertToBase64(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => result.next(reader.result!.toString());
    return result;
  }

  public hasPermission(...args: string[]) {
    let hasPermission = false;
    if (sessionStorage.getItem('currentUser')) {
      let currentUser = JSON.parse(sessionStorage.getItem('currentUser')!);
      if (args.indexOf(currentUser.role.name) > -1) {
        hasPermission = true;
      }
    }
    return hasPermission;
  }

  public hasModulePermission(module: string, action: string) {
    let hasPermission = false;
    if (sessionStorage.getItem('currentUser')) {
      let currentUser = JSON.parse(sessionStorage.getItem('currentUser')!);
      let roleAction = currentUser.role.actionList.find(
        (element) => element.module == module
      );
      if (
        roleAction &&
        ((action == 'ADD' && roleAction.addAction) ||
          (action == 'UPDATE' && roleAction.updateAction) ||
          (action == 'LIST' && roleAction.listAction) ||
          (action == 'DELETE' && roleAction.deleteAction))
      ) {
        hasPermission = true;
      }
    }
    return hasPermission;
  }

  public getImageUrl(imageName: string) {
    return this.HOME_URL + this.SERVER_URLS['IMAGE_URL'] + imageName + '/';
  }

  public getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  public checkFileExtension(fileExt: string) {
    if (this.FILE_EXTNS.indexOf(fileExt) > -1) return true;
    else return false;
  }

  //   public checkImportFileExtension(fileName) {
  //     if (this.IMPORT_FILE_EXTNS.indexOf(fileName) > -1) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   }

  //   public checkFileSize(photo) {
  //     if (Math.round(photo.size / 1024) > this.FILE_SIZE) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   }

  public checkImageExtension(imgName) {
    if (this.IMG_EXTNS.indexOf(imgName) > -1) return true;
    else return false;
  }

  //   public checkVideoExtension(videoName) {
  //     // Define an array of valid video extensions
  //    const VIDEO_EXTNS = ['.mp4', '.avi', '.mkv', '.mov', '.wmv'];

  //   // Check if the videoName has a valid video extension
  //      if (VIDEO_EXTNS.indexOf(videoName) > -1)
  //       return true;
  //    else
  //     return false;
  //   }
  // }

  public checkIfNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public checkIfLetter(event: any): void {
    const pattern = /^[A-Za-z\s]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public checkIfMarathiLetter(event: any): void {
    const pattern = /^[a-zA-Z\s\u0900-\u097F]+$/;

    let inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public checkIfAlphanumeric(event: any): void {
    const pattern = /^[A-Za-z0-9\s.,]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public validateString(event: any): void {
    const inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;

    // Prevent space at the beginning
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }

    // Prevent consecutive spaces
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }

    // Allow any other characters (numbers, symbols, etc.)
    // No need to prevent anything else
  }

  public checkNoStartingOrConsecutiveSpaces(event: any): void {
    const inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
  }

  public checkBankAccountNumber(event: any): void {
    const inputValue = event.target.value;
    const inputChar = event.data;

    const minLength = 10;
    const maxLength = 16;

    if (inputValue.length > maxLength) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ') {
      event.preventDefault();
      return;
    }
    if (!/^[0-9]*$/.test(inputChar)) {
      event.preventDefault();
      return;
    }
    if (inputValue.length < minLength) {
      // Handle feedback (e.g., show a message or alert) if necessary
    }
  }

  public checkNoStartingOrConsecutiveSpacesForAddress(event: any): void {
    const inputChar = String.fromCharCode(event.charCode);
    const inputValue = event.target.value;
    if (inputChar === ' ' && inputValue.length === 0) {
      event.preventDefault();
      return;
    }
    if (inputChar === ' ' && inputValue[inputValue.length - 1] === ' ') {
      event.preventDefault();
      return;
    }
  }

  public checkMaxLength(event: any): void {
    let input = event.target.value;
    input = input.replace(/[+-]/g, '');
    if (input.length > 2) {
      input = input.slice(0, 2);
    }
    event.target.value = input;
  }

  public dontAcceptSign(event: any): void {
    let input = event.target.value;
    input = input.replace(/[+-]/g, '');
    if (input.length > 0) {
      input = input.slice(0, 25);
    }
    event.target.value = input;
  }

  public onlyNumber(event: any): void {
    const pattern = /^[0-9]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
      return;
    }
    if (
      inputChar === '+' ||
      inputChar === '-' ||
      inputChar === ' ' ||
      inputChar === '.' ||
      inputChar === ','
    ) {
      event.preventDefault();
      return;
    }
  }
}
